'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'starship-freighter';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e03a';
var svgPathData = 'M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l228.4 88.8 0 80-160 0 0 64 160 0 0 80-96 37.3 0 74.7-128 0-18.2-18.2C298.5 473.9 261.4 480 224 480zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM112 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarshipFreighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;